import * as React from 'react';
import { memo, SVGProps } from 'react';

function UploadIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <g stroke="#fff" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.794 15.5s2.805.107 3.898-.375a4.78 4.78 0 0 0 2.785-3.875c.164-1.636-.582-3.434-1.992-4.304-.701-.431-1.52-.606-2.339-.677a9.862 9.862 0 0 0-1.399.062 5.46 5.46 0 0 0-4.74-3.81A5.328 5.328 0 0 0 6.543 4.41 5.5 5.5 0 0 0 5.429 6.59c-.054.213-.16.805-.16.805a4.197 4.197 0 0 0-1.484.842C2.471 9.413 2.151 11.42 2.886 13c.668 1.435 2.101 2.5 3.696 2.5h2.625M12 9.531v11.896" />
        <path d="m8.75 13.031 3.25-3.5 3.25 3.5" />
      </g>
    </svg>
  );
}

export function UploadIcon2x(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="25" viewBox="0 0 30 25" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7135 0.5V18.3477M14.7135 0.5L9.83853 5.75M14.7135 0.5L19.5885 5.75M29 16.8535V21.3535C29 22.1492 28.6839 22.9122 28.1213 23.4748C27.5587 24.0374 26.7957 24.3535 26 24.3535H3.5C2.70435 24.3535 1.94129 24.0374 1.37868 23.4748C0.81607 22.9122 0.5 22.1492 0.5 21.3535V16.8535"
        stroke="#0D0D0D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(UploadIcon);
